import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import { FadeInWhenInView } from "../../atoms/animations/FadeInWhenInView"
import Banner from "./Banner"
import Markdown from "react-markdown"
import Button from "../../atoms/buttons/Button"
import H1 from "../../atoms/typography/H1"
import { theme } from "../../theme"

const Body = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  font-family: "Inter", sans-serif;
  color: #ffffff;
`

interface Props {
  imageSrc: string
  title: string
  subtitle: string
  text: string
  ButtonTextSmall: string
  buttonUrl: string
  imageAlt?: string
}

const KuBanner: React.FC<Props> = ({ imageSrc, title, subtitle, text, ButtonTextSmall, buttonUrl, imageAlt }) => {
  return (
    <Banner imagePos="left" imageSrc={imageSrc} imageAlt={imageAlt ?? ""}>
      <Container>
        <Row align="center">
          <Col md={6} offset={{ md: 4 }}>
            <FadeInWhenInView>
              <H1 color={theme.colors.white} bold={true}>
                {title}
              </H1>
              <H1 color={theme.colors.white} bold={true}>
                {subtitle}
              </H1>
              <HorizontalSpacer spacing={2} />
              <div style={{ width: "75%" }}>
                <Body>
                  <Markdown>{text}</Markdown>
                </Body>
              </div>
            </FadeInWhenInView>
            <HorizontalSpacer spacing={2} />
            <FadeInWhenInView delay={0.3}>
              <a href={buttonUrl}>
                <Button title={ButtonTextSmall} size="big" variant="red" />
              </a>
            </FadeInWhenInView>
          </Col>
        </Row>
      </Container>
    </Banner>
  )
}

export default KuBanner
